<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="companyDocs"
      :row-key="record=>record.imageId"
      :pagination="false">
      <template
        slot="url-column"
        slot-scope="url">
        <div class="verification-details-photos__img-wrp">
          <img
            v-auth-image.src="`${url}`"
            @click="selectPhotoUrl"
            class="app__img-preview">
        </div>
      </template>
    </a-table>
    <photo-viewer
      :img-url="selectedDocUrl"
      :is-shown.sync="isImageViewerShown"
    />
  </div>
</template>

<script>
import { globalize } from '@/vue/filters/globalize'
import ATable from 'ant-design-vue/lib/table'
import PhotoViewer from '@/vue/common/PhotoViewer'
import 'ant-design-vue/lib/table/style/index.css'

const columns = ctx => {
  /* eslint-disable-next-line */
    const h = ctx.$createElement
  return [
    {
      dataIndex: 'group',
      key: 'group',
      title: globalize('verification-details-company.lbl-group'),
    },
    {
      dataIndex: 'docTypeId',
      key: 'docTypeId',
      title: globalize('verification-details-company.lbl-doc-type-id'),
    },
    {
      dataIndex: 'reviewAnswer',
      key: 'reviewAnswer',
      title: globalize('user-data.review-result'),
      customRender: (text, row) => {
        const className = `verification-details-company-sumsub-review-status-${text}`
        // vue antd table with custom renders very tricky
        return h(
          'span', {
            class: className,
          },
          text
        )
      },
    },
    {
      dataIndex: 'url',
      key: 'url',
      title: globalize('user-data.document'),
      scopedSlots: { customRender: 'url-column' },
    },
  ]
}

export default {
  name: 'veriication-details-company-docs',
  components: {
    PhotoViewer,
    ATable,
  },
  props: {
    companyDocs: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      selectedDocUrl: '',
      isImageViewerShown: false,
    }
  },

  computed: {
    columns () {
      return columns(this)
    },
  },
  methods: {
    selectPhotoUrl (ev) {
      this.selectedDocUrl = ev.target.attributes.src.value
      this.isImageViewerShown = true
    },
  },
}
</script>
